module.exports = __webpack_public_path__ + "static/media/monbaiti.f41bb054.ttf";